// broker's company search (include both aggregator and originatorBusiness)
export type CompaniesSearchComponentValue = {
  abn: string;
  entityName: string;
  salesforceId: string;
  originatorBusinessId: number | null,
  aggregatorId: number | null,
} | null;

